var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styles.droparea},[(_vm.textarea)?[_vm._t("default"),_c('div',{staticClass:"fs-14 color-gray-600",class:_vm.styles.or},[_vm._v("OR")])]:_vm._e(),_c('Dropzone',{class:{'small': _vm.textarea},attrs:{"loading":false,"mime":_vm.mime,"exclude":_vm.exclude},on:{"change":function($event){return _vm.$emit('change', $event)}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }